import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import * as auth from "../../store/ducks/auth.duck";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
import ModalAlterPassword from "./components/ModalAlterPassword/index";
import Swal from "sweetalert2";
import "./style.scss";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { withRouter } from "react-router-dom";
import { BsPerson } from "react-icons/bs";
import { ReactComponent as iconUser } from "../../assets/custom-icons/user-single-icon.svg";
import { SvgIcon } from "@material-ui/core";
import EnterIcon from "../../assets/icons/icon-enter.svg";
import { bindActionCreators } from "redux";
import { IoLockClosedOutline, IoLogOutOutline } from "react-icons/io5";

class UserProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      statusModal: false,
      viewModal: false,
      sucess: false,
      disabledClickOut: false,
      profileMenuOpen: false
    };
  }

  showMensage(sucess, error) {
    if (error) {
      Swal.fire(
        "Erro!",
        error ? error : "Erro ao alterar o status, tente novamente mais tarde.",
        "error"
      );
    } else if (sucess) {
      Swal.fire({
        title: "Sucesso!",
        text: "Senha alterada com sucesso.",
        icon: "success",
        showCancelButton: false,
        confirmButtonText: "Ok",
        cancelButtonText: "Sair"
      });
    }
  }

  render() {
    const { user, showHi, showBadge, history } = this.props;
    const userName = (
      user?.username ||
      user?.name ||
      "Usuário"
    ).toLocaleUpperCase("pt-BR");

    return (
      <>
        <ModalAlterPassword
          open={this.state.statusModal}
          setOpen={e => this.setState({ statusModal: e })}
          result={(sucess, error) => {
            this.showMensage(sucess, error);
            this.setState({ statusModal: false });
          }}
        />

        <Dropdown
          className="xv-user-profile"
          drop="down"
          alignRight
          disabled={false}
          show={this.state.profileMenuOpen}
          onToggle={profileMenuOpen => this.setState({ profileMenuOpen })}
        >
          <Dropdown.Toggle
            as={HeaderDropdownToggle}
            id="dropdown-toggle-user-profile"
          >
            <div className="kt-header__topbar-user">
              {showHi && (
                <span className="kt-header__topbar-welcome kt-hidden-mobile">
                  Olá,
                </span>
              )}

              {showHi && (
                <span className="kt-header__topbar-username kt-hidden-mobile">
                  {user?.name}
                </span>
              )}

              {showBadge && (
                <span className="kt-badge kt-badge--username kt-badge--unified-mainBlue kt-badge--lg kt-badge--rounded kt-badge--bold xv-user-profile__trigger">
                  <SvgIcon
                    component={iconUser}
                    viewBox="0 0 16 20"
                  />
                </span>
              )}
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu
            className="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-xl xv-user-menu"
          >
            <div className="xv-user-menu__header">
              <div className="xv-user-menu__avatar" aria-hidden="true">
                <BsPerson strokeWidth=".4px" size="24px" />
              </div>
              <div className="xv-user-menu__identity">
                <span>Conta do usuário</span>
                <strong>OLÁ, {userName}</strong>
              </div>
            </div>
            <div className="xv-user-menu__options">
              {user && user?.role?.name !== "PROSPECT" && (
                <>
                  {!history.location.pathname.includes("/admin") && (
                    <button
                      type="button"
                      className="xv-user-menu__option"
                      onClick={() => {
                        this.setState({ profileMenuOpen: false });
                        history.push("/admin");
                      }}
                    >
                      <span className="xv-user-menu__option-icon">
                        <img src={EnterIcon} alt="" />
                      </span>
                      <span className="xv-user-menu__option-copy">
                        <strong>Acesso interno</strong>
                        <small>Acessar a área administrativa</small>
                      </span>
                      <NavigateNextIcon className="xv-user-menu__chevron" />
                    </button>
                  )}
                </>
              )}

              <button
                type="button"
                className="xv-user-menu__option"
                onClick={() =>
                  this.setState({
                    profileMenuOpen: false,
                    statusModal: true
                  })
                }
              >
                <span className="xv-user-menu__option-icon">
                  <IoLockClosedOutline size="22px" />
                </span>
                <span className="xv-user-menu__option-copy">
                  <strong>Minha senha</strong>
                  <small>Alterar a senha de acesso</small>
                </span>
                <NavigateNextIcon className="xv-user-menu__chevron" />
              </button>

              <button
                type="button"
                className="xv-user-menu__option"
                onClick={() => {
                  this.setState({ profileMenuOpen: false });
                  history.push("/logout");
                }}
              >
                <span className="xv-user-menu__option-icon">
                  <IoLogOutOutline size="22px" />
                </span>
                <span className="xv-user-menu__option-copy">
                  <strong>Sair</strong>
                  <small>Encerrar acesso ao portal</small>
                </span>
                <NavigateNextIcon className="xv-user-menu__chevron" />
              </button>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </>
    );
  }
}

const mapStateToProps = ({ auth }) => ({
  user: auth.user
});

const mapActionsToProps = dispatch =>
  bindActionCreators({ logout: auth.actions.logout }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapActionsToProps)(UserProfile)
);
